module.exports = __webpack_public_path__ + "img/left-rear.98768216.png";